<template>
  <page-listado>
    <page-header title="Usuarios">
      <b-button variant="primary" size="sm" to="/usuarios/crear">
        <v-icon name="plus" width="16" />
        Crear usuario
      </b-button>
      <busqueda-rapida />
    </page-header>
    <tabla :usuarios="resultado.usuarios" />
    <paginacion :page-count="resultado.numeroPaginas" :page="parseInt(resultado.pagina)" />
  </page-listado>
</template>

<script>
import * as usuariosApi from "@/services/usuarios.js";
import Tabla from "./TablaUsuarios.vue";
export default {
  components: { Tabla },
  data() {
    return {
      resultado: {
        usuarios: [],
        numeroPaginas: 0,
        pagina: 1,
      },
    };
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.listar();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    listar() {
      return usuariosApi.listar(this.$route.query).then((resultado) => {
        this.resultado = resultado;
      });
    },
  },
};
</script>
